// extracted by mini-css-extract-plugin
export default {"mainContent":"MainContent_mainContent__d289W"};